export const Section = ({ id, eyebrow, title, kicker, children, className = "", containerClassName = "" }) => {
  return (
    <section id={id} className={`py-16 md:py-24 ${className}`}>
      <div className={`mx-auto max-w-7xl px-6 md:px-10 ${containerClassName}`}>
        {(eyebrow || title || kicker) && (
          <div className="max-w-3xl mb-10 md:mb-14">
            {eyebrow && <div className="eyebrow mb-4">{eyebrow}</div>}
            {title && <h2 className="font-display text-3xl sm:text-4xl md:text-5xl text-[var(--layor-navy)] leading-[1.05]">{title}</h2>}
            {kicker && <p className="mt-5 text-base md:text-lg text-[var(--layor-muted)] leading-relaxed">{kicker}</p>}
          </div>
        )}
        {children}
      </div>
    </section>
  );
};

export const Card = ({ children, className = "", ...rest }) => (
  <div className={`lift-card bg-white border border-[var(--layor-border)] rounded-2xl p-6 md:p-7 ${className}`} {...rest}>
    {children}
  </div>
);

export const CTA = ({ headline, sub, actions, dark = false }) => (
  <section className={`relative overflow-hidden ${dark ? "bg-[var(--layor-navy)] text-white" : "bg-white text-[var(--layor-navy)]"}`}>
    {dark && <div className="layr-noise" aria-hidden="true" />}
    <div className="mx-auto max-w-7xl px-6 md:px-10 py-16 md:py-24 relative">
      <div className="grid md:grid-cols-12 gap-10 items-end">
        <div className="md:col-span-8">
          <h2 className={`font-display text-3xl sm:text-4xl md:text-5xl leading-[1.05] ${dark ? "text-white" : "text-[var(--layor-navy)]"}`}>{headline}</h2>
          {sub && <p className={`mt-5 text-base md:text-lg leading-relaxed ${dark ? "text-white/75" : "text-[var(--layor-muted)]"}`}>{sub}</p>}
        </div>
        <div className="md:col-span-4 flex flex-wrap gap-3 md:justify-end">{actions}</div>
      </div>
    </div>
  </section>
);
